document.addEventListener('DOMContentLoaded', function(){
    // Show transition
    viewLoaded();

    setTimeout(() => {
        // Validate Session Redirect
        validateSession();

        // ScrollBarEvents
        scrollBar();
        resetScrollBar();

        // Function Load Dinamic Content on Template
        customContentLs();

        // Show Status Content Viewed on Modulo 1
        validateStatusModulo();

        // Dinamic Content on Same View
        validateStep1Content();
        validateStep2Content();

        // Collapse Tirbus Events
        collapseTribusEvents();

        // Collapse Recursos Events Scripting
        collapseSubmenuRecursosEvents();
        
        // Collapse Recursos Mobile Events Scripting
        collapseSubmenuRecursosMobileEvents();

        // Submnenu Configuracion Mobile Events Scripting
        submenuConfiguracionMobileEvents();

        // Set saved fontsize iteration
        setTribu();
        setFontSize();

        // Enable tooltips
        // enableTooltips();

        // Update Menu Module
        validateMenuModule();

        // Custom UI
        customizeUi();

        // Saved Navigation Links Data on Step 2
        toggleClassButtonsActive();

        // Default Load Carousels Controls
        defaultCarouselControls();

        // Set percent viewed by lesson
        calcProgress();

        // Dinamic footer
        dinamicFooter();

        // Dev Mode
        resetLocalStorage();
    }, 1500);
});

/********** Variables globales *********/
/** Content **/
// html
const html = document.querySelector('html');
// Body
const body = document.querySelector('body');
// Main
const main = document.querySelector('main');
// footer
const footer = document.querySelector('footer');

// Steps - Index Content
const step0 = document.querySelector('.step-0'); 
const step1 = document.querySelector('.step-1'); 
const step2 = document.querySelector('.step-2'); 

/* LECCION 1*/
const parentContentL1 = document.querySelector('.step-2 .leccion-1');
// Parent Content Lesson 1
const parentContentL1Activacion = document.querySelector('.step-2 .leccion-1 .activacion');
const parentContentL1Profundizacion = document.querySelector('.step-2 .leccion-1 .profundizacion');
const parentContentL1Dialogo = document.querySelector('.step-2 .leccion-1 .dialogo');
// Leccion 1 - Activacion Secciones
const listContentL1Activacion = document.querySelectorAll('.step-2 .leccion-1 .activacion .section');
// Leccion 1 - Profundizacion Secciones
const listContentL1Profundizacion = document.querySelectorAll('.step-2 .leccion-1 .profundizacion .section');
// Leccion 1 - Dialogo Secciones
const listContentL1Dialogo = document.querySelectorAll('.step-2 .leccion-1 .dialogo .section');
/**/

/* LECCION 2*/
const parentContentL2 = document.querySelector('.step-2 .leccion-2');
// Parent Content Lesson 2
const parentContentL2Activacion = document.querySelector('.step-2 .leccion-2 .activacion');
const parentContentL2Profundizacion = document.querySelector('.step-2 .leccion-2 .profundizacion');
const parentContentL2Dialogo = document.querySelector('.step-2 .leccion-2 .dialogo');
// Leccion 2 - Activacion Secciones
const listContentL2Activacion = document.querySelectorAll('.step-2 .leccion-2 .activacion .section');
// Leccion 2 - Profundizacion Secciones
const listContentL2Profundizacion = document.querySelectorAll('.step-2 .leccion-2 .profundizacion .section');
// Leccion 2 - Dialogo Secciones
const listContentL2Dialogo = document.querySelectorAll('.step-2 .leccion-2 .dialogo .section');
/**/

/* LECCION 3*/
const parentContentL3 = document.querySelector('.step-2 .leccion-3');
// Parent Content Lesson 3
const parentContentL3Activacion = document.querySelector('.step-2 .leccion-3 .activacion');
const parentContentL3Profundizacion = document.querySelector('.step-2 .leccion-3 .profundizacion');
const parentContentL3Dialogo = document.querySelector('.step-2 .leccion-3 .dialogo');
// Leccion 3 - Activacion Secciones
const listContentL3Activacion = document.querySelectorAll('.step-2 .leccion-3 .activacion .section');
// Leccion 3 - Profundizacion Secciones
const listContentL3Profundizacion = document.querySelectorAll('.step-2 .leccion-3 .profundizacion .section');
// Leccion 3 - Dialogo Secciones
const listContentL3Dialogo = document.querySelectorAll('.step-2 .leccion-3 .dialogo .section');
/**/

// Components
const navLesson = document.querySelector('.nav-lesson');

// Carousel Contents
const allCarouselContent = document.querySelectorAll('.carousel-content.carousel');
const allCarouselIndicators = document.querySelectorAll('.carousel-content.carousel .carousel-indicators button');
// Get all Carousel Items by Id
// L1 - Status
const carouselItemsL1Activacion = document.querySelectorAll('#carouselL1Activacion .carousel-inner .carousel-item');
const carouselItemsL1Profundizacion = document.querySelectorAll('#carouselL1Profundizacion .carousel-inner .carousel-item');
const carouselItemsL1Dialogo = document.querySelectorAll('#carouselL1Dialogo .carousel-inner .carousel-item');

// L2 - Status
const carouselItemsL2Activacion = document.querySelectorAll('#carouselL2Activacion .carousel-inner .carousel-item');
const carouselItemsL2Profundizacion = document.querySelectorAll('#carouselL2Profundizacion .carousel-inner .carousel-item');
const carouselItemsL2Dialogo = document.querySelectorAll('#carouselL2Dialogo .carousel-inner .carousel-item');

// L3 - Status
const carouselItemsL3Activacion = document.querySelectorAll('#carouselL3Activacion .carousel-inner .carousel-item');
const carouselItemsL3Profundizacion = document.querySelectorAll('#carouselL3Profundizacion .carousel-inner .carousel-item');
const carouselItemsL3Dialogo = document.querySelectorAll('#carouselL3Dialogo .carousel-inner .carousel-item');

/********** DOM Scripting *********/
// Debug LocalStorage
function debugLocalStorage(){
    Object.keys(localStorage).forEach(function (key){
        console.table(`-------\nLocal Storage -> Key: ${key} | Value: ${localStorage.getItem(key)}\n-------`);
    });
}

// Reset LocalStorage
function resetLocalStorage(){
    const buttons = document.querySelectorAll('.resetLocalStorage');

    buttons.forEach(function(button){
        button.addEventListener('click', function(){
            deleteDataSession();
        });
    });
}

// Get Instance Collapse Tribus
function collapseTribus(){
    const collapseSubmenuModule = new bootstrap.Collapse('#collapseSelectTribu', {
        toggle: false,
        hide: true
    });

    return collapseSubmenuModule;
}

// Events Collapse Tribus
function collapseTribusEvents(){
    // List option on collapse
    const options = document.querySelectorAll('.options-tribus li');

    // Inputs for metada
    const tribus = document.querySelector('#tribus');

    // Get id collapse Tribu
    const collapseSelectTribu = document.querySelector('#collapseSelectTribu');

    // Get button picker
    const btnPickerTribus = document.querySelector('#btn-picker-tribus');


    // Get text icon picker
    const textIconPicker = document.querySelector('#icon-picker');

    options.forEach(function(option){
        
        option.addEventListener('click', function(event){
            const getData = event.target.dataset.click;
            tribus.setAttribute('value', getData);

            options.forEach(function(option){
                option.classList.remove('active');
            });

            btnPickerTribus.textContent = getData;

            event.target.classList.add('active');
            collapseTribus().hide();
        });
    });

    collapseSelectTribu.addEventListener('show.bs.collapse', function(event){
        textIconPicker.innerHTML = '▴';
    });
    collapseSelectTribu.addEventListener('hide.bs.collapse', function(event){
        textIconPicker.innerHTML = '▾';
    });
}

// Get Instance Collapse Sumbmenu Module 
function collapseSubmenuModule(){
    const submenuModule = new bootstrap.Collapse('#collapseSubmenuModule', {
        toggle: false,
        hide: true
    });

    return submenuModule;
}

// Events Collapse Recursos
function collapseSubmenuRecursosEvents(){
    // const btnSubmenuRecursos = document.querySelector('#btn-submenu-recursos');
    const textIconPicker = document.querySelector('#icon-picker-recursos');

    const collapseSubmenuRecursos = document.querySelector('#collapseSubmenuModule');
    const instanceCollapse = new bootstrap.Collapse(`#${collapseSubmenuRecursos.id}`, {
        toggle: false,
        hide: true
    });

    // btnSubmenuRecursos.addEventListener('mouseover', function(){
    //     collapseSubmenuModule().show();
    // });
    // collapseSubmenuRecursos.addEventListener('mouseleave', function(){
    //     collapseSubmenuModule().hide();
    //     btnSubmenuRecursos.classList.remove('active');
    // });

    // Get text icon picker

    // Modal Créditos
    const modalContentCreditos = document.querySelector('#modal-creditos');
    modalContentCreditos.addEventListener('show.bs.modal', function(event){
        instanceCollapse.hide();
    });
    
    collapseSubmenuRecursos.addEventListener('show.bs.collapse', function(event){
        // btnSubmenuRecursos.classList.add('active');
        textIconPicker.innerHTML = '▴';
    });
    collapseSubmenuRecursos.addEventListener('hide.bs.collapse', function(event){
        textIconPicker.innerHTML = '▾';
        // btnSubmenuRecursos.classList.remove('active');
    });
}

// Get Instance Collapse Sumbmenu Module Mobile
function collapseSubmenuModuleMobile(){
    const submenuModule = new bootstrap.Collapse('#collapseSubmenuModuleMobile', {
        toggle: false,
        hide: true
    });

    return submenuModule;
}

// Events Collapse Sumbmenu Module Mobile
function collapseSubmenuRecursosMobileEvents(){
    const collapseSubmenuRecursosMobile = document.querySelector('#collapseSubmenuModuleMobile');
    const instanceCollapse = new bootstrap.Collapse(`#${collapseSubmenuRecursosMobile.id}`, {
        toggle: false,
        hide: true
    });

    // Modal Créditos
    const modalContentCreditos = document.querySelector('#modal-creditos');
    modalContentCreditos.addEventListener('show.bs.modal', function(event){
        instanceCollapse.hide();
    });

    collapseSubmenuRecursosMobile.addEventListener('show.bs.collapse', function(event){
        body.classList.add('stop-scrolling');
    });
    collapseSubmenuRecursosMobile.addEventListener('hide.bs.collapse', function(event){
        body.classList.remove('stop-scrolling');
    });
}

// Events Collapse Sumbmenu Configuracion Mobile
function submenuConfiguracionMobileEvents(){
    const collapseSubmenuConfiguracionMobile = document.querySelector('#buttonSubmenuConfiguracionMobile');
    const contentSubmenu = document.querySelector('#custom-ui');
    const textIconPicker = document.querySelector('#icon-picker-configuracion-mobile');
    
    collapseSubmenuConfiguracionMobile.addEventListener('click', function(event){
        if(contentSubmenu.classList.contains('active')){
            textIconPicker.innerHTML = '▼';
            contentSubmenu.className = '';
            contentSubmenu.classList.add('d-none', 'd-sm-none', 'd-md-flex',);
        }
        else{
            textIconPicker.innerHTML = '▲';
            contentSubmenu.className = '';
            contentSubmenu.classList.add('d-flex', 'd-sm-flex', 'd-md-flex', 'active', 'bounce-in-fwd');
        }
    });
}

// Reset CustomUi Bar Mobile
function resetCustomUiMobile(){
    const contentSubmenu = document.querySelector('#custom-ui');
    const textIconPicker = document.querySelector('#icon-picker-configuracion-mobile');

    textIconPicker.innerHTML = '▼';
    contentSubmenu.className = '';
    contentSubmenu.classList.add('d-none', 'd-sm-none', 'd-md-flex',);    
}

/****/

// Save LocalStorage
function saveDataSession(metaTag, value){
    return localStorage.setItem(metaTag, value);
}

// Get Values from LocalStorage
function getValueSession(key){
    return localStorage.getItem(key);
}

// Delete Specific LocalStorage item
function deleteDataItem(key){
    localStorage.removeItem(key);
}

// Delete LocalStorage
function deleteDataSession(){
    localStorage.clear();
    location.reload();
    // debugLocalStorage();
}

// Validate Previous Session
function validateSession(){
    if(getValueSession('TM_Subtema')){
        validateStepLoad(step2);
        validateStep2LastVisited();
    }
    else if(getValueSession('TM_Tribu')){
        validateStepLoad(step1);
    }
    else{
        validateStepLoad(step0);
        validateInit();
    }
}

// Validate whats load when the page reload -> Saved Session
// STEPS - Default validateStepLoad(step1);
function validateStepLoad(stepId){
    const steps = document.querySelectorAll('[data-element="step-content"]');

    steps.forEach(function(step){
        if(step === stepId){
            step.classList.remove('d-none');
        }
        else{
            step.classList.add('d-none');
        }
    });
    
    // Pause Media Video
    stopVideo();

    // Pause Media Audio
    stopAudio();

    // Reset Speech Audio 
    resetAudioSpeech();

    // Reset customUi Mobile
    resetCustomUiMobile();

    // Reset scroll - Elements
    resetScrollElements();
}

// Validate Form Inpunt on the Intro Of the Project
function validateInit() {
    const buttonInit = document.querySelector('[data-validate="tribu-selected"]');
    
    const validateTribus = document.querySelector('#validate-input-tribus');

    buttonInit.addEventListener('mouseover', function(){
        if(tribus.value === ''){
            validateTribus.textContent = 'Seleccione una comunidad para continuar';
            validateTribus.classList.remove('d-none');
        }
        else{
            validateTribus.textContent = '';  
            validateTribus.classList.add('d-none');

            return true;
        }
    });

    buttonInit.addEventListener('click', function(){
        if(tribus.value === ''){
            validateTribus.textContent = 'Seleccione una comunidad para continuar';
            validateTribus.classList.remove('d-none');
        }
        else{
            // LocalStorage Save Variable
            resetScrollBar();
            validateStepLoad(step1);

            validateTribus.textContent = '';  
            validateTribus.classList.add('d-none');

            saveDataSession('TM_Tribu', tribus.value);
            saveDataSession('TM_Modulo', 'Taller Misak');

            // Update Tribu Head
            setTribu();

            // Update Menu Module
            validateMenuModule();

            // Show transition view loaded
            viewLoaded();

            // Dinamic footer
            dinamicFooter();
        }
    });
}

// STEP-1 VALIDATION
// Show Status Content Viewed on Modulo 1
function validateStatusModulo(){
    // Get values of progress located in LocalStorage
    const getStatusL1Activacion = `${getValueSession('TM_StatusL1Activacion')}`;
    const getStatusL1Profundizacion = `${getValueSession('TM_StatusL1Profundizacion')}`;
    const getStatusL1Dialogo = `${getValueSession('TM_StatusL1Dialogo')}`;

    const getStatusL2Activacion = `${getValueSession('TM_StatusL2Activacion')}`;
    const getStatusL2Profundizacion = `${getValueSession('TM_StatusL2Profundizacion')}`;
    const getStatusL2Dialogo = `${getValueSession('TM_StatusL2Dialogo')}`;

    const getStatusL3Activacion = `${getValueSession('TM_StatusL3Activacion')}`;
    const getStatusL3Profundizacion = `${getValueSession('TM_StatusL3Profundizacion')}`;
    const getStatusL3Dialogo = `${getValueSession('TM_StatusL3Dialogo')}`;

    // Get all icons Status
    // Lección 1
    const iconL1Completed = document.querySelectorAll('.icon-l1-completed');
    const iconStatusL1Activacion = document.querySelectorAll('.icon-status-l1-activacion');
    const iconStatusL1Profundizacion = document.querySelectorAll('.icon-status-l1-profundizacion');
    const iconStatusL1Dialogo = document.querySelectorAll('.icon-status-l1-dialogo');

    // Lección 2
    const iconL2Completed = document.querySelectorAll('.icon-l2-completed');
    const iconStatusL2Activacion = document.querySelectorAll('.icon-status-l2-activacion');
    const iconStatusL2Profundizacion = document.querySelectorAll('.icon-status-l2-profundizacion');
    const iconStatusL2Dialogo = document.querySelectorAll('.icon-status-l2-dialogo');

    // Lección 3
    const iconL3Completed = document.querySelectorAll('.icon-l3-completed');
    const iconStatusL3Activacion = document.querySelectorAll('.icon-status-l3-activacion');
    const iconStatusL3Profundizacion = document.querySelectorAll('.icon-status-l3-profundizacion');
    const iconStatusL3Dialogo = document.querySelectorAll('.icon-status-l3-dialogo');

    // Tapic Validation
    function validateTopicStatus(topic, iconStatusTopic, targetList){
        if(topic === 'completado'){
            // array.forEach(icon => {
            // });

            iconStatusTopic.forEach(function(icon){
                icon.parentNode.classList.add('active');

                icon.classList.remove('icon-dash-circle');
                icon.classList.add('icon-check');
            });

            targetList.forEach(function(item){
                item.dataset.itemStatus = "completo";
            });
        }
        else{
            iconStatusTopic.forEach(function(icon){
                icon.parentNode.classList.add('remove');

                icon.classList.remove('icon-check');
                icon.classList.add('icon-dash-circle');
            });
        }
    }
    // Lección 1
    validateTopicStatus(getStatusL1Activacion, iconStatusL1Activacion, carouselItemsL1Activacion);
    validateTopicStatus(getStatusL1Profundizacion, iconStatusL1Profundizacion, carouselItemsL1Profundizacion);
    validateTopicStatus(getStatusL1Dialogo, iconStatusL1Dialogo, carouselItemsL1Dialogo);

    // Lección 2
    validateTopicStatus(getStatusL2Activacion, iconStatusL2Activacion, carouselItemsL2Activacion);
    validateTopicStatus(getStatusL2Profundizacion, iconStatusL2Profundizacion, carouselItemsL2Profundizacion);
    validateTopicStatus(getStatusL2Dialogo, iconStatusL2Dialogo, carouselItemsL2Dialogo);

    // Lección 3
    validateTopicStatus(getStatusL3Activacion, iconStatusL3Activacion, carouselItemsL3Activacion);
    validateTopicStatus(getStatusL3Profundizacion, iconStatusL3Profundizacion, carouselItemsL3Profundizacion);
    validateTopicStatus(getStatusL3Dialogo, iconStatusL3Dialogo, carouselItemsL3Dialogo);


    // lesson Validation
    function validateLessonStatus(topic1, topic2, topic3, iconStatusLesson){
        if(topic1 === 'completado' && topic2 === 'completado' && topic3 === 'completado'){
            iconStatusLesson.forEach(function(icon){
                icon.classList.remove('d-none');
            });
        }
        else{
            iconStatusLesson.forEach(function(icon){
                icon.classList.add('d-none');
            });
        }
    }
    // Lección 1
    validateLessonStatus(getStatusL1Activacion, getStatusL1Profundizacion, getStatusL1Dialogo, iconL1Completed);
    // Lección 2
    validateLessonStatus(getStatusL2Activacion, getStatusL2Profundizacion, getStatusL2Dialogo, iconL2Completed);
    // Lección 3
    validateLessonStatus(getStatusL3Activacion, getStatusL3Profundizacion, getStatusL3Dialogo, iconL3Completed);

    // debugLocalStorage();
}

function validateStep1Content(){
    const buttons = document.querySelectorAll('[data-element="button-to-step-1"]');

    buttons.forEach(function(button){
        button.addEventListener('click', function(event){
            // Reset the event button las clicked render content
            saveDataSession('TM_LastSubtopicVisited', '');
            
            // Change value lesson title id
            saveDataSession('TM_Leccion', 'Inicio');

            // Reset the Topic title
            saveDataSession('TM_Tema', 'Ninguno');

            // Reset Home Path
            saveDataSession('TM_Subtema', '');

            if(button.dataset.element === 'button-to-step-1'){
                // Toggle Header
                toggleHeader();

                // Hide all Toast
                hideToast();

                // Show Status Content Viewed on Modulo 1
                validateStatusModulo();

                // Hide Steps 0,1 and show Step 2
                // resetScrollBar();
                validateStepLoad(step1);

                // Function Load Dinamic Content on Template
                customContentLs();

                // Update Menu Module view of STEP 2
                validateMenuModule();

                // Hide Collapse Submenu Module
                collapseSubmenuModule().hide();

                // Hide Collapse Submenu Module Mobile
                collapseSubmenuModuleMobile().hide();

                // Show transition view loaded
                viewLoaded();

                // Saved Navigation Links Data on Step 1
                toggleClassButtonsActive();

                // Dinamic footer
                dinamicFooter();

                // Redirect to table of contents
                setTimeout(() => {
                    const sectionTop = document.querySelector('#table-of-contents').offsetTop;
        
                    window.scrollTo({
                        top: sectionTop,
                        behavior: "smooth"
                    });
                }, 0);
            }
            else{
                // Hide All Steps
                validateStepLoad('hide');
            }
        });
    });
}

// STEP-2 VALIDATION
// Validate active item on STEP With Routes and Interactions
function validateStep2LastVisited(){
    switchContentStep2(`${getValueSession('TM_LastSubtopicVisited')}`, `${getValueSession('TM_Leccion')}`, `${getValueSession('TM_Tema')}`);
    // debugLocalStorage();
}

// Switch content on Step 2
function switchContentStep2(lastVisited, lesson, topic){
    toggleHeader();

    switch (lesson) {
        /* LECCION 1 */
        case 'Lección 1':
            parentContentL1.classList.remove('d-none');
            parentContentL2.classList.add('d-none');
            parentContentL3.classList.add('d-none');

            // Hide all Toast
            hideToast();

            switch (topic) {
                case 'l1-activacion':
                    // Show content
                    parentContentL1Activacion.classList.remove('d-none');
                    parentContentL1Profundizacion.classList.add('d-none');
                    parentContentL1Dialogo.classList.add('d-none');
        
                    listContentL1Activacion.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-1 .activacion .section-${getDataLoad}`); 
                    });
        
                    
                    // Load Scripting - Components Interactive - Profundizacion
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // Show toast 
                        toggleToast('carouselL1Activacion');
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);

                    break;

                case 'l1-profundizacion':
                    // Show content
                    parentContentL1Activacion.classList.add('d-none');
                    parentContentL1Profundizacion.classList.remove('d-none');
                    parentContentL1Dialogo.classList.add('d-none');
        
                    listContentL1Profundizacion.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-1 .profundizacion .section-${getDataLoad}`);  
                    });
        
                    
                    // Load Scripting - Components Interactive - Profundizacion                    
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // Show toast 
                        toggleToast('carouselL1Profundizacion');
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);
                    
                    break;

                case 'l1-dialogo':
                    parentContentL1Activacion.classList.add('d-none');
                    parentContentL1Profundizacion.classList.add('d-none');
                    parentContentL1Dialogo.classList.remove('d-none');
        
                    listContentL1Dialogo.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-1 .dialogo .section-${getDataLoad}`); 
                    });

                    // Save Completed Status on LocalStorage
                    saveDataSession('TM_StatusL1Dialogo', 'completado');

                    // Complete single carousel
                    singleCarouselComplete(carouselItemsL1Dialogo);

                    // Show Status Content Viewed on Modulo 1
                    validateStatusModulo();

                    // Load Scripting - Components Interactive - Profundizacion
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);
                    
                    setTimeout(() => {
                        // Show toast 
                        toggleToast('carouselL1Dialogo');
                    }, 4500);

                    break;

                // By default
                default:
                    parentContentL1Activacion.classList.add('d-none');
                    parentContentL1Profundizacion.classList.add('d-none');
                    parentContentL1Dialogo.classList.add('d-none');
                    break;
            }
            break;

        /* LECCION 2 */
        case 'Lección 2':
            parentContentL1.classList.add('d-none');
            parentContentL2.classList.remove('d-none');
            parentContentL3.classList.add('d-none');

            // Hide all Toast
            hideToast();

            switch (topic) {
                case 'l2-activacion':
                    // Show content
                    parentContentL2Activacion.classList.remove('d-none');
                    parentContentL2Profundizacion.classList.add('d-none');
                    parentContentL2Dialogo.classList.add('d-none');
        
                    listContentL2Activacion.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-2 .activacion .section-${getDataLoad}`); 
                    });
        
                    // Save Completed Status on LocalStorage
                    saveDataSession('TM_StatusL2Activacion', 'completado');

                    // Complete single carousel
                    singleCarouselComplete(carouselItemsL2Activacion);

                    // Show Status Content Viewed on Modulo 1
                    validateStatusModulo();

                    // Load Scripting - Components Interactive - Profundizacion
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);
                    
                    setTimeout(() => {
                        // Show toast 
                        toggleToast('carouselL2Activacion');
                    }, 4500);

                    break;

                case 'l2-profundizacion':
                    // Show content
                    parentContentL2Activacion.classList.add('d-none');
                    parentContentL2Profundizacion.classList.remove('d-none');
                    parentContentL2Dialogo.classList.add('d-none');
        
                    listContentL2Profundizacion.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-2 .profundizacion .section-${getDataLoad}`);  
                    });
        
                    // Load Scripting - Components Interactive - Profundizacion           
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // Control Multimedia Nodo
                        controlMultimediaL2Profundizacion();
                        // Show toast 
                        toggleToast('carouselL2Profundizacion');
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);
                    
                    break;

                case 'l2-dialogo':
                    parentContentL2Activacion.classList.add('d-none');
                    parentContentL2Profundizacion.classList.add('d-none');
                    parentContentL2Dialogo.classList.remove('d-none');
        
                    listContentL2Dialogo.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-2 .dialogo .section-${getDataLoad}`); 
                    });

                    // Save Completed Status on LocalStorage
                    saveDataSession('TM_StatusL2Dialogo', 'completado');

                    // Complete single carousel
                    singleCarouselComplete(carouselItemsL2Dialogo);

                    // Show Status Content Viewed on Modulo 1
                    validateStatusModulo();

                    // Load Scripting - Components Interactive - Profundizacion
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);
                    
                    setTimeout(() => {
                        // Show toast 
                        toggleToast('carouselL2Dialogo');
                    }, 4500);

                    break;

                // By default
                default:
                    parentContentL2Activacion.classList.add('d-none');
                    parentContentL2Profundizacion.classList.add('d-none');
                    parentContentL2Dialogo.classList.add('d-none');
                    break;
            }
            break;

        /* LECCION 3 */
        case 'Lección 3':
            parentContentL1.classList.add('d-none');
            parentContentL2.classList.add('d-none');
            parentContentL3.classList.remove('d-none');

            // Hide all Toast
            hideToast();

            switch (topic) {
                case 'l3-activacion':
                    // Show content
                    parentContentL3Activacion.classList.remove('d-none');
                    parentContentL3Profundizacion.classList.add('d-none');
                    parentContentL3Dialogo.classList.add('d-none');
        
                    listContentL3Activacion.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-3 .activacion .section-${getDataLoad}`); 
                    });
        
                    // Save Completed Status on LocalStorage
                    saveDataSession('TM_StatusL3Activacion', 'completado');

                    // Complete single carousel
                    singleCarouselComplete(carouselItemsL3Activacion);

                    // Show Status Content Viewed on Modulo 1
                    validateStatusModulo();

                    // Load Scripting - Components Interactive - Profundizacion
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);
                    
                    setTimeout(() => {
                        // Show toast 
                        toggleToast('carouselL3Activacion');
                    }, 4500);
        
                    break;

                case 'l3-profundizacion':
                    // Show content
                    parentContentL3Activacion.classList.add('d-none');
                    parentContentL3Profundizacion.classList.remove('d-none');
                    parentContentL3Dialogo.classList.add('d-none');
        
                    listContentL3Profundizacion.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-3 .profundizacion .section-${getDataLoad}`);  
                    });
        
                    // Save Completed Status on LocalStorage
                    saveDataSession('TM_StatusL3Profundizacion', 'completado');

                    // Complete single carousel
                    singleCarouselComplete(carouselItemsL3Profundizacion);

                    // Show Status Content Viewed on Modulo 1
                    validateStatusModulo();

                    // Load Scripting - Components Interactive - Profundizacion       
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);
                    
                    setTimeout(() => {
                        // Show toast 
                        toggleToast('carouselL3Profundizacion');
                    }, 4500);
                    
                    break;

                case 'l3-dialogo':
                    parentContentL3Activacion.classList.add('d-none');
                    parentContentL3Profundizacion.classList.add('d-none');
                    parentContentL3Dialogo.classList.remove('d-none');
        
                    listContentL3Dialogo.forEach(function(section){
                        let getDataLoad = section.dataset.load;
                        let getDataFetch = section.dataset.fetch;  
        
                        section.innerHTML = '';
                        fetchContent(`./content/${lastVisited}${getDataLoad}.html`, getDataFetch, `.leccion-3 .dialogo .section-${getDataLoad}`); 
                    });

                    // Load Scripting - Components Interactive - Profundizacion           
                    setTimeout(() => {
                        // Nav Progress Interactions
                        progressComponent();
                        // Show toast 
                        toggleToast('carouselL3Dialogo');
                        // Set percent viewed by lesson
                        calcProgress();
                    }, 1500);

                    break;

                // By default
                default:
                    parentContentL3Activacion.classList.add('d-none');
                    parentContentL3Profundizacion.classList.add('d-none');
                    parentContentL3Dialogo.classList.add('d-none');
                    break;
            }
            break;

        default:
            parentContentL1.classList.add('d-none');
            parentContentL2.classList.add('d-none');
            parentContentL3.classList.add('d-none');
            break;
    }
}

// Validate content to load on STEP 2 -> Content Lesson
function validateStep2Content(){
    const buttons = document.querySelectorAll('[data-element="button-to-step-2"]');

    buttons.forEach(function(button){
        
        button.addEventListener('click', function(event){
            // Remove class active of all buttons
            buttons.forEach(function(button){
                button.classList.remove('active');
            });

            // Save the event button las clicked render content
            const getContent = event.target.dataset.content;
            saveDataSession('TM_LastSubtopicVisited', getContent);
            
            // Save the lesson title id
            const getLesson = event.target.dataset.lesson;
            saveDataSession('TM_Leccion', getLesson);

            // Save the Topic title
            const getTopic = event.target.dataset.topic;
            saveDataSession('TM_Tema', getTopic);

            // Save the subtopic title
            const getSubtopic = event.target.title;
            saveDataSession('TM_Subtema', getSubtopic);

            // Validate Click
            if(button.dataset.element === 'button-to-step-2'){
                // Toggle Header
                toggleHeader();

                // Hide Steps 0,1 and show Step 2
                resetScrollBar();
                validateStepLoad(step2);

                // Function Load Dinamic Content on Template
                customContentLs();
                
                // Update Menu Module view of STEP 2
                validateMenuModule();
                
                // Load content
                switchContentStep2(getContent, getLesson, getTopic);
                
                // Hide Collapse Submenu Module
                collapseSubmenuModule().hide();

                // Hide Collapse Submenu Module Mobile
                collapseSubmenuModuleMobile().hide();

                // Show transition view loaded
                viewLoaded();

                // Saved Navigation Links Data on Step 2
                toggleClassButtonsActive();

                // Dinamic footer
                dinamicFooter();
            }
            else{
                // Hide All Steps
                validateStepLoad('hide');
            }

            // debugLocalStorage();
        });

        
    });
}

// Validate Class Active on Step 2
function toggleClassButtonsActive(){
    const getLesson = `${getValueSession('TM_Leccion')}`;
    const getTopic = `${getValueSession('TM_Tema')}`;

    // Buttons with data-topic l1-
    const btnsHome = document.querySelectorAll('[data-element="button-to-step-1"]');

    // Buttons with data-topic l1-
    const btnsL1Activacion = document.querySelectorAll('[data-topic="l1-activacion"]');
    const btnsL1Profundizacion = document.querySelectorAll('[data-topic="l1-profundizacion"]');
    const btnsL1Dialogo = document.querySelectorAll('[data-topic="l1-dialogo"]');

    // Buttons with data-topic l2-
    const btnsL2Activacion = document.querySelectorAll('[data-topic="l2-activacion"]');
    const btnsL2Profundizacion = document.querySelectorAll('[data-topic="l2-profundizacion"]');
    const btnsL2Dialogo = document.querySelectorAll('[data-topic="l2-dialogo"]');

    // Buttons with data-topic l3-
    const btnsL3Activacion = document.querySelectorAll('[data-topic="l3-activacion"]');
    const btnsL3Profundizacion = document.querySelectorAll('[data-topic="l3-profundizacion"]');
    const btnsL3Dialogo = document.querySelectorAll('[data-topic="l3-dialogo"]');

    switch (getLesson) {
        case 'Inicio':
            // For home buttons
            btnsHome.forEach(function(button){
                button.classList.add('active');
            });

            // For lesson 1 - Reset
            btnsL1Activacion.forEach(function(button){
                button.classList.remove('active');
            });
            btnsL1Profundizacion.forEach(function(button){
                button.classList.remove('active');
            });
            btnsL1Dialogo.forEach(function(button){
                button.classList.remove('active');
            });

            // For lesson 2 - Reset
            btnsL2Activacion.forEach(function(button){
                button.classList.remove('active');
            });
            btnsL2Profundizacion.forEach(function(button){
                button.classList.remove('active');
            });
            btnsL2Dialogo.forEach(function(button){
                button.classList.remove('active');
            });

            // For lesson 3 - Reset
            btnsL3Activacion.forEach(function(button){
                button.classList.remove('active');
            });
            btnsL3Profundizacion.forEach(function(button){
                button.classList.remove('active');
            });
            btnsL3Dialogo.forEach(function(button){
                button.classList.remove('active');
            });
            break;

        case 'Lección 1':
            // For home buttons
            btnsHome.forEach(function(button){
                button.classList.remove('active');
            });

            if(getTopic === 'l1-activacion'){
                btnsL1Activacion.forEach(function(button){
                    button.classList.add('active');
                });
            }
            else if(getTopic === 'l1-profundizacion'){
                btnsL1Profundizacion.forEach(function(button){
                    button.classList.add('active');
                });
            }
            else{
                btnsL1Dialogo.forEach(function(button){
                    button.classList.add('active');
                });
            }
            break;

        case 'Lección 2':
            // For home buttons
            btnsHome.forEach(function(button){
                button.classList.remove('active');
            });

            if(getTopic === 'l2-activacion'){
                btnsL2Activacion.forEach(function(button){
                    button.classList.add('active');
                });
            }
            else if(getTopic === 'l2-profundizacion'){
                btnsL2Profundizacion.forEach(function(button){
                    button.classList.add('active');
                });
            }
            else{
                btnsL2Dialogo.forEach(function(button){
                    button.classList.add('active');
                });
            }
            break;

        case 'Lección 3':
            // For home buttons
            btnsHome.forEach(function(button){
                button.classList.remove('active');
            });

            if(getTopic === 'l3-activacion'){
                btnsL3Activacion.forEach(function(button){
                    button.classList.add('active');
                });
            }
            else if(getTopic === 'l3-profundizacion'){
                btnsL3Profundizacion.forEach(function(button){
                    button.classList.add('active');
                });
            }
            else{
                btnsL3Dialogo.forEach(function(button){
                    button.classList.add('active');
                });
            }
            break;
    
        default:
            break;
    }
}

/** CUSTOM UI **/
// Custom FontSize - Toggler
function customizeUi(){
    // Custom UI
    const customUiIdioma = document.querySelector('#custom-ui-idioma');

    const customUiAudioOn = document.querySelector('#custom-ui-audio-on');
    const customUiAudioOff = document.querySelector('#custom-ui-audio-off');
    
    const customUiFontSize = document.querySelector('#custom-ui-font-size');
    
    const customUiInstructivo = document.querySelector('#custom-ui-instructivo');
    
    const customUiContraste = document.querySelector('#custom-ui-contraste');
    
    const customUiFullScreen = document.querySelector('#custom-ui-full-screen');
    const customUiFullScreenExit = document.querySelector('#custom-ui-full-screen-exit');
    
    // let incrementConfig = 0;
    let incrementConfig = `${getValueSession('TM_FontSizeId')}`;
    let increment = parseInt(incrementConfig, 10);
    
    // Custom UI - Audio
    function speechQuery(context, state){
        const synth = window.speechSynthesis;
        
        const templateString = new SpeechSynthesisUtterance();
        templateString.lang = 'es-MX';
        
        switch (state) {
            case 'speak':
                // synth.speak(templateString);  
                // Set content to read and format the finally content without spaces and breaklines
                const content = document.querySelector(`${context}`).textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                const formattedContent = content.replace(/\s+/g, ' ');
        
                // Get the number of words from textContent
                const numberOfWords = Math.ceil(formattedContent.split(' ').length/500);

                // Array to save the sentences
                let listOfSentences = [] // This is our arrray.
                for(let i = 0; i < numberOfWords; i++){
                    listOfSentences[i] = [];
                }

                //  Create a 2D array
                let wordCount = 0; 
                for (let x = 0; x < Math.ceil(formattedContent.split(' ').length/500); x++) {
                    for (let j = 0; j < 500; j++) {
                        listOfSentences[x][j] = formattedContent.split(' ')[wordCount++];
                    }

                    // This run read event
                    templateString.text = listOfSentences[x].join(' ');
                    synth.speak(templateString);

                    // Debug
                    // console.log(wordCount);
                    // console.log(listOfSentences);
                    // console.log(formattedContent);
                }

                templateString.addEventListener('end', function(){
                    customUiAudioOn.classList.add('d-none');
                    customUiAudioOff.classList.remove('d-none');
                });

                break;

            case 'cancel':
                synth.cancel(); 
                break;
        
            default:
                break;
        };

    }
    
    function switchContentForSpeech(){
        const getTopic = `${getValueSession('TM_Tema')}`;
        // console.log(getTopic);

        if(getTopic === 'Ninguno'){
            return '.step-1';
        }
        // Lección 1
        else if(getTopic === 'l1-activacion'){
            return '.step-2 .leccion-1 .activacion .carousel .carousel-inner .carousel-item.active';
        }
        else if(getTopic === 'l1-profundizacion'){
            return '.step-2 .leccion-1 .profundizacion .carousel .carousel-inner .carousel-item.active';
        }
        else if(getTopic === 'l1-dialogo'){
            return '.step-2 .leccion-1 .dialogo .carousel .carousel-inner .carousel-item.active';
        }

        // Lección 2
        else if(getTopic === 'l2-activacion'){
            return '.step-2 .leccion-2 .activacion .carousel .carousel-inner .carousel-item.active';
        }
        else if(getTopic === 'l2-profundizacion'){
            return '.step-2 .leccion-2 .profundizacion .carousel .carousel-inner .carousel-item.active';
        }
        else if(getTopic === 'l2-dialogo'){
            return '.step-2 .leccion-2 .dialogo .carousel .carousel-inner .carousel-item.active';
        }

        // Lección 3
        else if(getTopic === 'l3-activacion'){
            return '.step-2 .leccion-3 .activacion .carousel .carousel-inner .carousel-item.active';
        }
        else if(getTopic === 'l3-profundizacion'){
            return '.step-2 .leccion-3 .profundizacion .carousel .carousel-inner .carousel-item.active';
        }
        else if(getTopic === 'l3-dialogo'){
            return '.step-2 .leccion-3 .dialogo .carousel .carousel-inner .carousel-item.active';
        }

        else{
            return false;
        }
    }

    customUiAudioOff.addEventListener('click', function(){
        customUiAudioOff.classList.add('d-none');
        customUiAudioOn.classList.remove('d-none');
        
        speechQuery(switchContentForSpeech(), 'speak');
    });
    
    customUiAudioOn.addEventListener('click', function(){
        customUiAudioOn.classList.add('d-none');
        customUiAudioOff.classList.remove('d-none');

        speechQuery(switchContentForSpeech(), 'cancel');
    });
    

    // Custom UI - FontSize
    customUiFontSize.addEventListener('click', function(){
        increment++;
        // console.log(increment);

        if(increment === 1){
            html.className = '';
            html.classList.add('font-size-medium');
        }
        else if(increment === 2){
            html.className = '';
            html.classList.add('font-size-big');
        }
        else if(increment === 3){
            html.className = '';
            html.classList.add('font-size-bigger');
        }
        else{
            html.className = '';
            html.classList.add('font-size-default');
            
            increment = 0;
        }

        saveDataSession('TM_FontSize', html.className);
        saveDataSession('TM_FontSizeId', increment);
        
        // debugLocalStorage();
    });

    // Custom UI - Instructivo
    const modalContentInstructivo = document.querySelector('#modal-instrucciones');
    const modalInstructivo = new bootstrap.Modal('#modal-instrucciones', {
        keyboard: true,
    });
    customUiInstructivo.addEventListener('click', function(){
        modalInstructivo.show();
    });
    modalContentInstructivo.addEventListener('hidden.bs.modal', event => {
        stopVideo();
    });

    // Custom UI - Contraste
    customUiContraste.addEventListener('click', function(){
        if(body.classList.contains('high-contrast')){
            body.classList.remove('high-contrast');
            saveDataSession('TM_Contrast', 'contrast-off');

            customUiContraste.classList.remove('icon-sol');
            customUiContraste.classList.add('icon-luna');
        }
        else{
            body.classList.add('high-contrast');
            saveDataSession('TM_Contrast', 'high-contrast');
            
            customUiContraste.classList.remove('icon-luna');
            customUiContraste.classList.add('icon-sol');
        }
    });

    // Custom UI - FullScreen
    customUiFullScreen.addEventListener('click', function(){
        customUiFullScreen.classList.add('d-none');
        customUiFullScreenExit.classList.remove('d-none');

        openFullscreen();
    });
    customUiFullScreenExit.addEventListener('click', function(){
        customUiFullScreenExit.classList.add('d-none');
        customUiFullScreen.classList.remove('d-none');

        closeFullscreen();
    });

    function openFullscreen(){
        const elem = document.documentElement;
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } 
        else if (elem.msRequestFullscreen) {/* Safari */
            elem.msRequestFullscreen();
        } 
        else if (elem.webkitRequestFullscreen) { /* IE11 */
            elem.webkitRequestFullscreen();
        }
    }

    function closeFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } 
        else if (document.webkitExitFullscreen) { /* Safari */
            document.webkitExitFullscreen();
        } 
        else if (document.msExitFullscreen) { /* IE11 */
            document.msExitFullscreen();
        }
    }

    document.addEventListener("fullscreenchange", function() { 
        // console.log('fullscreen state changed');
        if(document.webkitIsFullScreen === false){
            customUiFullScreenExit.classList.add('d-none');
            customUiFullScreen.classList.remove('d-none');
        }
      
    });
}

// Validate update Menu Module
function validateMenuModule(){
    const getPath = `${getValueSession('TM_LastPathVisited')}`;
    const getModule = `${getValueSession('TM_Modulo')}`;
    const getLesson = `${getValueSession('TM_Leccion')}`;
    const getTopic = `${getValueSession('TM_Tema')}`;
    const getSubtopic = `${getValueSession('TM_Subtema')}`;

    // Get tribu value
    const getTribu = `${getValueSession('TM_Tribu')}`;

    // Components - Preimported by fetch
    const submenuRecursos = document.querySelector('#submenu-recursos');

    // Init default values to localstorage
    if(getPath === 'null' && getModule === 'null' && getLesson === 'null' && getTopic === 'null' && getSubtopic === 'null'){
        // Set path route
        saveDataSession('TM_Modulo', 'Taller Misak');
        saveDataSession('TM_Leccion', 'Inicio');
        saveDataSession('TM_Tema', 'Ninguno');
        saveDataSession('TM_Subtema', '');
    }
    // Update view to Step 0 -> Login
    else if(getTribu === ''){
        // Hide content
        navLesson.classList.add('d-none');
        submenuRecursos.classList.add('d-none');
    }
    // Update view to Step 2 -> Lesson -> Subtopic
    else if(getSubtopic !== ''){
        // Construct path url with subtopic
        const renderPath = `
        <span class="tribu-mobile d-flex d-sm-flex d-md-none">
            ${getValueSession('TM_Tribu')}
        </span>

        <span class="content">
            ${getValueSession('TM_Modulo')} 
            <span>▸</span> 
            ${getValueSession('TM_Leccion')} 
            <span>▸</span> 
            ${getValueSession('TM_Subtema')}
        <span>
        `;
        saveDataSession('TM_LastPathVisited', renderPath);
    
        const itemListModule = document.querySelector('#ruta-modulo li');
        itemListModule.innerHTML = `${getValueSession('TM_LastPathVisited')}`;
    
        navLesson.classList.remove('d-none');
        submenuRecursos.classList.remove('d-none');
    }
    // Update view to Step 1 -> Inicio
    else{
        // Construct path url without subtopic
        const renderPath = `
            <span class="tribu-mobile d-flex d-sm-flex d-md-none">
                ${getValueSession('TM_Tribu')}
            </span>
            
            <span class="content">
                ${getValueSession('TM_Modulo')} 
                <span>▸</span> 
                ${getValueSession('TM_Leccion')}
            <span>
        `;
        saveDataSession('TM_LastPathVisited', renderPath);

        const itemListModule = document.querySelector('#ruta-modulo li');
        itemListModule.innerHTML = `${getValueSession('TM_LastPathVisited')}`;

        navLesson.classList.remove('d-none');

        // submenuRecursos.classList.add('d-none');
        submenuRecursos.classList.remove('d-none');
    }
}

// Set fontsize
function setFontSize(){
    const fontSize = `${getValueSession('TM_FontSize')}`;
    const fontSizeId = `${getValueSession('TM_FontSizeId')}`;

    if(fontSize === 'null' && fontSizeId === 'null'){
        saveDataSession('TM_FontSize', 'font-size-default');
        saveDataSession('TM_FontSizeId', 0);
    }
    
    html.className = '';
    html.classList.add(`${getValueSession('TM_FontSize')}`);

    // debugLocalStorage();
}

// Set tribu
function setTribu(){
    const tribuValue = `${getValueSession('TM_Tribu')}`;
    const tribuHead = document.querySelector('#tribu-head');

    if(tribuValue === 'null'){
        saveDataSession('TM_Tribu', '');
    } 
    else if(tribuValue === ''){
        tribuHead.classList.add('d-none');
    }
    else{
        // Tribu Head
        // Set Header Value Tribu
        tribuHead.textContent = `${getValueSession('TM_Tribu')}`;
        tribuHead.classList.remove('d-none');
    
        // debugLocalStorage();
    }

}

//BARRA DE CARGA SCROLL
// Scroll Bar - Progress
function scrollBar(){
    // Elements
    const scrollBarProgress = document.querySelector('#progress-bar');
    
    window.addEventListener('scroll', function(){
        // Position on NavLesson by scroll direction with offset
        // Offset
        let scrollTopGlobal = document.documentElement.scrollTop;
        let offsetHeader = document.querySelector('header').offsetHeight;
        let offsetNavLesson = document.querySelector('.nav-lesson').offsetHeight;

        if (scrollTopGlobal <= offsetHeader){
            // DownScroll code
            // console.log('DOWN');
            navLesson.classList.remove('component-fixed');
            step2.style.marginTop = '0px';
        } 
        else {
            // UpScroll code
            // console.log('UP');
            navLesson.classList.add('component-fixed');
            step2.style.marginTop = `${offsetNavLesson}px`;
        }
        scrollPos = scrollTopGlobal <= 0 ? 0 : scrollTopGlobal; // For Mobile or negative scrolling

        // Scroll bar progress Scipting
        let winScroll = Math.round(document.documentElement.scrollTop);
        let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        let scrolled = (winScroll / height) * 105;

        scrollBarProgress.style.width = scrolled + "%";
    });

}

// Scrollbar percent reset - Fixed
function resetScrollBar(){
    // Scroll Bar Progress
    const scrollBarProgress = document.querySelector('#progress-bar');

    scrollBarProgress.style.width = 0 + "%";
    window.scrollTo(0, 0);
}

// NavLesson reset - Fixed
function resetScrollElements(){
    // Nav Lesson
    navLesson.classList.remove('component-fixed');
}

// Reset Audio Speech When Load Other View
function resetAudioSpeech(){
    const customUiAudioOn = document.querySelector('#custom-ui-audio-on');
    const customUiAudioOff = document.querySelector('#custom-ui-audio-off');

    const synth = window.speechSynthesis;
    synth.cancel();
    
    customUiAudioOn.classList.add('d-none');
    customUiAudioOff.classList.remove('d-none');
}

// // Reset Carousel Lesson
// function resetCarouselsLessons(){
//     allCarouselContent.forEach(carousel => {
//         const component = new bootstrap.Carousel(carousel);
//         component.to(0);
//     });
// }

// Show transition when content loads
function viewLoaded(){
    const loaderSection = document.querySelector('.load-content');

    body.classList.add('stop-scrolling');
    loaderSection.classList.remove('loaded');

    setTimeout(() => {
        body.classList.remove('stop-scrolling');
        loaderSection.classList.add('loaded');
        // loaderSection.classList.remove('loaded');
    }, 3000);
}

// Default Carousel Controls
function defaultCarouselControls(){
    const allCarouselInner = document.querySelectorAll('.carousel-content.carousel .carousel-inner');

    // Default load
    allCarouselInner.forEach(function(carouselInner){

        let navigationPrev = document.querySelector(`#${carouselInner.parentElement.id} .control-prev`);
        let navigationNext = document.querySelector(`#${carouselInner.parentElement.id} .control-next`);

        if(carouselInner.childElementCount <= 1){
            navigationPrev.classList.add('d-none');
            navigationNext.classList.add('d-none');
        }

        else if(carouselInner.childElementCount > 1){
            navigationPrev.classList.add('d-none');
            navigationNext.classList.remove('d-none');
        }

        else{
            return false;
        }
    });
}

// Calculate percent lesson viewed sync with localStorage -> StatusLesson
function calcProgress(active){
    const getLesson = `${getValueSession('TM_Leccion')}`;
    const getTopic = `${getValueSession('TM_Tema')}`;

    const progressPercent = document.querySelector('#percent-viewed');
    const paginators = document.querySelectorAll('.carousel-paginator');

    // Complete Items L1
    const itemsCompleteL1Activacion = document.querySelectorAll(`#carouselL1Activacion .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL1Activacion = document.querySelector(`#carouselL1Activacion .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const itemsCompleteL1Profundizacion = document.querySelectorAll(`#carouselL1Profundizacion .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL1Profundizacion = document.querySelector(`#carouselL1Profundizacion .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const itemsCompleteL1Dialogo = document.querySelectorAll(`#carouselL1Dialogo .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL1Dialogo = document.querySelector(`#carouselL1Dialogo .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const totalL1ItemsComplete = itemsCompleteL1Activacion + itemsCompleteL1Profundizacion + itemsCompleteL1Dialogo;

    // Complete Items L2
    const itemsCompleteL2Activacion = document.querySelectorAll(`#carouselL2Activacion .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL2Activacion = document.querySelector(`#carouselL2Activacion .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const itemsCompleteL2Profundizacion = document.querySelectorAll(`#carouselL2Profundizacion .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL2Profundizacion = document.querySelector(`#carouselL2Profundizacion .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const itemsCompleteL2Dialogo = document.querySelectorAll(`#carouselL2Dialogo .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL2Dialogo = document.querySelector(`#carouselL2Dialogo .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const totalL2ItemsComplete = itemsCompleteL2Activacion + itemsCompleteL2Profundizacion + itemsCompleteL2Dialogo;

    // Complete Items L3
    const itemsCompleteL3Activacion = document.querySelectorAll(`#carouselL3Activacion .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL3Activacion = document.querySelector(`#carouselL3Activacion .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const itemsCompleteL3Profundizacion = document.querySelectorAll(`#carouselL3Profundizacion .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL3Profundizacion = document.querySelector(`#carouselL3Profundizacion .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const itemsCompleteL3Dialogo = document.querySelectorAll(`#carouselL3Dialogo .carousel-inner .carousel-item[data-item-status='completo']`).length;
    const itemActiveL3Dialogo = document.querySelector(`#carouselL3Dialogo .carousel-inner .carousel-item.active`).dataset.itemIndex;

    const totalL3ItemsComplete = itemsCompleteL3Activacion + itemsCompleteL3Profundizacion + itemsCompleteL3Dialogo;

    // Total Values
    const totalL1Items = carouselItemsL1Activacion.length + carouselItemsL1Profundizacion.length + carouselItemsL1Dialogo.length;
    const itemL1Percent = 100 / totalL1Items;

    const totalL2Items = carouselItemsL2Activacion.length + carouselItemsL2Profundizacion.length + carouselItemsL2Dialogo.length;
    const itemL2Percent = 100 / totalL2Items;

    const totalL3Items = carouselItemsL3Activacion.length + carouselItemsL3Profundizacion.length + carouselItemsL3Dialogo.length;
    const itemL3Percent = 100 / totalL3Items;

    function addPercent(current, complete){
        let currentValue = current * complete;
        let percentValue = currentValue.toFixed(0);
        return percentValue;
    }

    function setPaginator(target, total){
        paginators.forEach(item => {
            item.textContent = '[ ' + `${target} de ${total}` + ' ]';
        });
    }

    switch (getLesson) {
        case 'Lección 1':
            progressPercent.textContent = `${addPercent(itemL1Percent, totalL1ItemsComplete)}%`;

            switch (getTopic) {
                case 'l1-activacion':
                    setPaginator(itemActiveL1Activacion, carouselItemsL1Activacion.length);
                    break;
                case 'l1-profundizacion':
                    setPaginator(itemActiveL1Profundizacion, carouselItemsL1Profundizacion.length);
                    break;
                case 'l1-dialogo':
                    setPaginator(itemActiveL1Dialogo, carouselItemsL1Dialogo.length);
                    break;
                    
                default:
                    break;
            }
            break;
        case 'Lección 2':
            progressPercent.textContent = `${addPercent(itemL2Percent, totalL2ItemsComplete)}%`;

            switch (getTopic) {
                case 'l2-activacion':
                    setPaginator(itemActiveL2Activacion, carouselItemsL2Activacion.length);
                    break;
                case 'l2-profundizacion':
                    setPaginator(itemActiveL2Profundizacion, carouselItemsL2Profundizacion.length);
                    break;
                case 'l2-dialogo':
                    setPaginator(itemActiveL2Dialogo, carouselItemsL2Dialogo.length);
                    break;
                    
                default:
                    break;
            }
            break;
        case 'Lección 3':
            progressPercent.textContent = `${addPercent(itemL3Percent, totalL3ItemsComplete)}%`;

            switch (getTopic) {
                case 'l3-activacion':
                    setPaginator(itemActiveL3Activacion, carouselItemsL3Activacion.length);
                    break;
                case 'l3-profundizacion':
                    setPaginator(itemActiveL3Profundizacion, carouselItemsL3Profundizacion.length);
                    break;
                case 'l3-dialogo':
                    setPaginator(itemActiveL3Dialogo, carouselItemsL3Dialogo.length);
                    break;
                    
                default:
                    break;
            }
            break;
        default:
            break;
    }
}

// Complete single carousel -> Dialogo de saberes
function singleCarouselComplete(list){
    list.forEach(function(item){
        item.dataset.itemStatus = 'completo';
    });
}

// Nav Progress Scripting
function progressComponent(){
    // Template view content
    function validateCarouselPaginator(){
        function syncViewTop(){
            window.scrollTo(0, 0);
        }

        function carouselEventControl(event){
            
            let eventTargetId = document.querySelector(`#${event.target.id} .carousel-inner`);
            let childEventCount = eventTargetId.childElementCount - 1; // -1 for sincronice index with item of view
            
            let navigationPrev = document.querySelector(`#${event.target.id} .control-prev`);
            let navigationNext = document.querySelector(`#${event.target.id} .control-next`);
            
            if(event.to === 0){
                navigationPrev.classList.add('d-none');
                navigationNext.classList.remove('d-none');
            }
            else if(event.to >= 1 && event.to < childEventCount){
                navigationPrev.classList.remove('d-none');
                navigationNext.classList.remove('d-none');
            }
            else{
                navigationPrev.classList.remove('d-none');
                navigationNext.classList.add('d-none');
            }
        }
        
        // Save DataProgress on LocalStorage
        function saveLessonProgress(event){
            const getLesson = `${getValueSession('TM_Leccion')}`;
            const getTopic = `${getValueSession('TM_Tema')}`;

            const eventTargetIdChildren = document.querySelectorAll(`#${event.target.id} .carousel-inner .carousel-item`);

            function completeContent(list){
                list.forEach(function(item, index){
                    if(event.to === index){

                        if(item.previousElementSibling === null){
                            item.dataset.itemStatus = 'completo';
                        }
                        else{
                            item.dataset.itemStatus = 'completo';
                            item.previousElementSibling.dataset.itemStatus = 'completo';
                        }

                        calcProgress(event.relatedTarget.dataset.itemIndex);
                    }
                });
            }

            function validateCarouselStatus(list){
                const listItems = list.length;
                const eventItems = document.querySelectorAll(`#${event.target.id} .carousel-inner .carousel-item[data-item-status='completo']`).length;
    
                if(listItems === eventItems){
                    return true;
                }
                else{
                    return false;
                }
            }

            // Carousel Lesson -> LocalStorage
            switch (getLesson) {
                case 'Lección 1':
                    switch (getTopic) {
                        case 'l1-activacion':
                            completeContent(eventTargetIdChildren);
                            if(validateCarouselStatus(eventTargetIdChildren) === true){
                                saveDataSession('TM_StatusL1Activacion', 'completado');
                                toggleToast('carouselL1Activacion');
                            }
                            break;

                        case 'l1-profundizacion':
                            completeContent(eventTargetIdChildren);
                            if(validateCarouselStatus(eventTargetIdChildren) === true){
                                saveDataSession('TM_StatusL1Profundizacion', 'completado');
                                toggleToast('carouselL1Profundizacion');
                            }
                            break;

                        // case 'l1-dialogo':
                        //     completeContent(eventTargetIdChildren);
                        //     if(validateCarouselStatus(eventTargetIdChildren) === true){
                        //         saveDataSession('TM_StatusL1Dialogo', 'completado');
                        //         toggleToast('carouselL1Dialogo');
                        //     }
                        //     break;
                            
                        default:
                            break;
                    }
                    break;

                case 'Lección 2':
                    switch (getTopic) {
                        // case 'l2-activacion':
                        //     completeContent(eventTargetIdChildren);
                        //     if(validateCarouselStatus(eventTargetIdChildren) === true){
                        //         saveDataSession('TM_StatusL2Activacion', 'completado');
                        //         toggleToast('carouselL2Activacion');
                        //     }
                        //     break;

                        case 'l2-profundizacion':
                            completeContent(eventTargetIdChildren);
                            if(validateCarouselStatus(eventTargetIdChildren) === true){
                                saveDataSession('TM_StatusL2Profundizacion', 'completado');
                                toggleToast('carouselL2Profundizacion');
                            }
                            break;

                        // case 'l2-dialogo':
                        //     completeContent(eventTargetIdChildren);
                        //     if(validateCarouselStatus(eventTargetIdChildren) === true){
                        //         saveDataSession('TM_StatusL2Dialogo', 'completado');
                        //         toggleToast('carouselL2Dialogo');
                        //     }
                        //     break;
                            
                        default:
                            break;
                    }
                    break;

                case 'Lección 3':
                    switch (getTopic) {
                        // case 'l3-activacion':
                        //     completeContent(eventTargetIdChildren);
                        //     if(validateCarouselStatus(eventTargetIdChildren) === true){
                        //         saveDataSession('TM_StatusL3Activacion', 'completado');
                        //         toggleToast('carouselL3Activacion');
                        //     }
                        //     break;

                        // case 'l3-profundizacion':
                        //     completeContent(eventTargetIdChildren);
                        //     if(validateCarouselStatus(eventTargetIdChildren) === true){
                        //         saveDataSession('TM_StatusL3Profundizacion', 'completado');
                        //         toggleToast('carouselL3Profundizacion');
                        //     }
                        //     break;

                        case 'l3-dialogo':
                            completeContent(eventTargetIdChildren);
                            if(validateCarouselStatus(eventTargetIdChildren) === true){
                                saveDataSession('TM_StatusL3Dialogo', 'completado');
                                toggleToast('carouselL3Dialogo');
                            }
                            break;
                            
                        default:
                            break;
                    }
                    break;

                default:
                    break;
            }

            // debugLocalStorage();
        }

        // Lessons Controller
        allCarouselContent.forEach(function(carousel){
            carousel.addEventListener('slid.bs.carousel', function(event){
                syncViewTop();
                carouselEventControl(event);
                saveLessonProgress(event);

                // Show Status Content Viewed on Modulo 1
                validateStatusModulo();

                // Reset Multimedia
                resetAudioSpeech();
                stopVideo();
                stopAudio();
            });
        });
    }
    validateCarouselPaginator();
}

// Toggle Header
function toggleHeader(){
    // Header
    const header = document.querySelector('#header-template');
    
    const getTopic = getValueSession('TM_Tema');
    
    if(getTopic === 'Ninguno' ){
        header.classList.remove('d-none');
    }
    else{
        header.classList.add('d-none');
    }
};

// Hide toast
function hideToast(){
    // Toast Content
    const toast = document.querySelector('#toastLesson');
    const toastInstance = new bootstrap.Collapse(toast, {
        toggle: false,
        hide: true
    });

    toastInstance.hide();
}

// Toggle toast
function toggleToast(toastActivator){
    // Toast Content
    const toast = document.querySelector('#toastLesson');
    const toastInstance = new bootstrap.Collapse(toast, {
        toggle: false,
        hide: true
    });

    const toastContent = document.querySelectorAll(`#${toast.id} .toast-actions .content-toast`);

    toastContent.forEach(function(content){
        const data = content.dataset.activator;

        if(toastActivator === data){
            content.classList.remove('d-none');
        }
        else{
            content.classList.add('d-none');
        }
    });

    
    function toastActions(){
        const carouselLastItem = document.querySelector(`#${toastActivator} .carousel-inner .carousel-item:last-of-type`); 

        if(carouselLastItem.classList.contains('active')){
            toastInstance.show();   
        }
        else{
            toastInstance.hide();
        }
    }
    toastActions();
}


// Dinamic footer
function dinamicFooter(){
    const getLesson = `${getValueSession('TM_Leccion')}`;

    // Footer Content
    const footerContentMain = document.querySelector('#footer-content-main');
    const footerContentL1 = document.querySelector('#footer-content-l1');
    const footerContentL2 = document.querySelector('#footer-content-l2');
    const footerContentL3 = document.querySelector('#footer-content-l3');
        
    // }
    switch (getLesson) {
        case 'Lección 1':
            footerContentMain.classList.add('d-none');
            footerContentL1.classList.remove('d-none');
            footerContentL2.classList.add('d-none');
            footerContentL3.classList.add('d-none');
            break;

        case 'Lección 2':
            footerContentMain.classList.add('d-none');
            footerContentL1.classList.add('d-none');
            footerContentL2.classList.remove('d-none');
            footerContentL3.classList.add('d-none');
            break;

        case 'Lección 3':
            footerContentMain.classList.add('d-none');
            footerContentL1.classList.add('d-none');
            footerContentL2.classList.add('d-none');
            footerContentL3.classList.remove('d-none');
            break;
    
        default:
            footerContentMain.classList.remove('d-none');
            footerContentL1.classList.add('d-none');
            footerContentL2.classList.add('d-none');
            footerContentL3.classList.add('d-none');
            break;
    }

    // debugLocalStorage();
}

// Function Load Dinamic Content on Template
function customContentLs(){
    const configTribu = document.querySelectorAll('.config-tribu');
    const getTribu = `${getValueSession('TM_Tribu')}`

    if(getTribu === '' || getTribu === 'null'){
        return false;
    }
    else{
        configTribu.forEach(function(tribu){
            tribu.textContent = getTribu;
        });
    }

    // debugLocalStorage();
}

// Stop Media Video
function stopVideo(){
    const videos = document.querySelectorAll('video');

    videos.forEach(function(video){
        video.pause();
    });
}

// Stop Media Audio
function stopAudio(){
    const audios = document.querySelectorAll('audio');

    audios.forEach(function(audio){
        audio.pause();
    });
}

// Break Audio and Video on modal events
function modalControl(){
    const allModal = document.querySelectorAll('.modal');
    
    allModal.forEach(function(modal){
        modal.addEventListener('shown.bs.modal', function(){
            stopVideo();
            stopAudio();
        });
        modal.addEventListener('hidden.bs.modal', function(){
            stopVideo();
            stopAudio();
        });
    });
}

// Stop Multimedia L2 Profundizacion
function controlMultimediaL2Profundizacion(){
    const modalL2Prof01 = document.querySelector('#modal-l2-prof-02-06');
    modalL2Prof01.addEventListener('hidden.bs.modal', function (){
        stopAudio();
    });
}

function enableTooltips(){
    // Enable tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
}
/****/
